import Immutable from 'immutable';
import { createSelector } from 'reselect';

export const getOpenModals = createSelector(
  [state => state.getIn(['ui', 'modal'], Immutable.Map())],
  modals => modals.filter(modal => !!modal.get('open'))
);

export default {
  getOpenModals
};
